import Vue from 'vue'
import App from './App'

import iView from 'iview';
Vue.use(iView);
import './language';

import moment from 'moment';
Vue.prototype.$moment = moment;
import router from './router'
import components from './views/components';
Vue.use(components);
import store from './store'
import './style/index.scss' // Global styles

Vue.config.productionTip = false

//Global prompt configuration: Change the retention time to 2s
Vue.prototype.$Message.config({
    top: 50,
    duration: 3
});

new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js